"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSOLoginComponent = void 0;
const mithril_component_1 = require("../../components/mithril.component");
const spinner_1 = require("../../components/spinner/spinner");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const classnames_1 = require("../../util/classnames");
const page_1 = require("../../page/page");
const auth_component_style_1 = require("./auth.component.style");
(0, theme_1.addStyles)(auth_component_style_1.Style);
class SSOLoginComponent extends mithril_component_1.IMithrilComponent {
    viewButton() {
        return (0, mithril_1.m)('button', {
            className: (0, classnames_1.classNames)('mdl-button', 'mdl-button--raised', auth_component_style_1.CSS.button),
            onclick: () => services_1.Services.SSO.login(),
        }, (0, i18n_1.Translate)(i18n_1.T.LOGIN_WITH_AUTH0));
    }
    get nodes() {
        // remove the flash of the login screen as the user is authenticating!
        // the ui renders before the sso authenticate state resolves, so without
        // this it feels janky.
        if (services_1.Services.SSO.inFlight || services_1.Services.SSO.isAuthenticated) {
            return (0, mithril_1.m)('div', {
                className: auth_component_style_1.CSS.container,
            }, (0, mithril_1.m)('div', {
                className: auth_component_style_1.CSS.centered,
            }, spinner_1.Spinner.view()));
        }
        return (0, mithril_1.m)('div', {
            className: auth_component_style_1.CSS.container,
        }, [
            (0, mithril_1.m)('div', {
                className: auth_component_style_1.CSS.text,
            }, (0, mithril_1.m)('div', {
                className: auth_component_style_1.CSS.textInner,
            }, (0, i18n_1.Translate)(i18n_1.T.LOGIN_OFFICE))),
            (0, mithril_1.m)('div', {
                className: auth_component_style_1.CSS.padding,
            }, this.viewButton()),
            (0, mithril_1.m)('div', {
                className: auth_component_style_1.CSS.padding,
            }, (0, mithril_1.m)('a', {
                className: auth_component_style_1.CSS.link,
                onclick: () => services_1.Services.Route.go(page_1.IkePageName.userSSOMigrate),
            }, (0, i18n_1.Translate)(i18n_1.T.LOGIN_NO_AUTH0_ACCOUNT))),
        ]);
    }
}
exports.SSOLoginComponent = SSOLoginComponent;
//# sourceMappingURL=login.js.map